export default {
  types: {
    _primaryControls: {
      width: '2rem',
    },
    _increment: {
      name: 'ลำดับ',
      width: '3rem',
      class: 'text-center',
    },
    code: {
      name: 'รหัสลูกหนี้',
      width: '6rem',
    },
    name: {
      name: 'ชื่อบริษัท/ห้าง/ร้าน/บุคคล',
      width: '1fr',
    },
    address: {
      name: 'ที่อยู่',
      width: '1fr',
      filter: (val: any) => `${val.address} ${val.province?.nameInThai} ${val.district?.nameInThai ? val.district?.nameInThai : ''} ${val.subdistrict?.nameInThai ? val.subdistrict?.nameInThai : ''}`,
    },
    taxId: {
      name: 'เลขประจำตัวผู้เสียภาษี',
      width: '12rem',
      class: {
        cell: 'text-center',
        text: 'text-center',
      },
    },
    contactName: {
      name: 'ผู้ติดต่อ',
      width: '8rem',
    },
    contactPhone: {
      name: 'เบอร์ติดต่อ',
      width: '8rem',
    },
    createdBy: {
      name: 'ผู้ทำรายการ',
      width: '8rem',
      class: {
        cell: 'text-right',
        text: 'text-right',
      },
    },
  },
  sortable: [
    'debtorCode',
    'customerName',
    'address',
    'number',
    'contactName',
    'actionBy',
  ],
};
